var _path, _path2, _path3, _circle, _circle2, _circle3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8496 37.4375L23.8496 26.5284",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7402 26.5284L30.7402 32.185L35.1847 37.4375",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8652 26.5284L17.8652 32.185L13.4208 37.4375",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.3347,
    cy: 38.5266,
    r: 2.27273,
    transform: "rotate(90 36.3347 38.5266)",
    stroke: "#C63031",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.3347,
    cy: 38.5266,
    r: 2.27273,
    transform: "rotate(90 24.3347 38.5266)",
    stroke: "#C63031",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.27273,
    cy: 3.27273,
    r: 2.27273,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 9.06055 35.2539)",
    stroke: "#C63031",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1441 8.42944L17.1444 8.42919C19.1437 6.71695 21.6948 5.77031 24.337 5.76172C29.7164 5.76249 34.1322 9.72997 34.6112 14.7782L34.6857 15.5643L35.4677 15.6741C38.4842 16.0975 40.79 18.5946 40.79 21.6048C40.79 24.9076 38.0066 27.5972 34.5616 27.5972H15.1303C11.1227 27.5972 7.88086 24.468 7.88086 20.6188C7.88086 17.3027 10.2817 14.5188 13.5139 13.8101L14.1748 13.6652L14.2861 12.9979C14.5495 11.4196 15.5989 9.7517 17.1441 8.42944Z",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/Cloud.3579af0019fc020a6975515ff6e798ff.svg";
export { ForwardRef as ReactComponent };